import { render, staticRenderFns } from "./ControlDisplay.vue?vue&type=template&id=bc7022c2&"
import script from "./ControlDisplay.vue?vue&type=script&lang=js&"
export * from "./ControlDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports